module.exports = __webpack_public_path__ + "static/img/2.1f4e0b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/2.png
// module id = KISO
// module chunks = 0